<template>
  <layout-content>
    <form-component />
  </layout-content>
</template>

<script>
  import FormComponent from '@pbx/components/contacts/form';
  export default {
    components: {
      FormComponent
    }
  };
</script>
